var map = {
	"./01_error_code.json": "XCkz",
	"./02_timestamp.json": "oPkH",
	"./03_digital_rule.json": "WihS",
	"./04_rate_limits.json": "p+dP",
	"./05_system_time.json": "lC7j"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZP2+";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/api/basic \.json$
// module id = ZP2+
// module chunks = 3